import {globals, globalUser} from "../modules/globals.js";
import {loadAvailableCallupsPage, loadHomePage} from "./home-page.js";
import {disabledMenuButtonHandler, playEventHandler, resetMenuButtonClickHandlers} from "./game-menu.js";
import {showEventPosterPageGraphic} from "./graphics.js";
import {showPlaySegmentPage, showUpdatesContainers} from "./segments.js";
import {showPlayMatchPage} from "./matches.js";
import {
    getChampionshipDisplayName,
    getFeudHypeIncreasedHtml,
    getFeudPotentialHtml, getStarRatingHtml, getViewershipText,
    makeGameRequest, showFactionReputationData,
    updateGamePointsAndFans,
} from "./ui-helpers.js";
import {endEventRequest} from "../modules/events.js";
import {commaSeparate, getCurrentGame, toTitleCase} from "../modules/helpers.js";
import {simulateCompetitors} from "../modules/simulator.js";
import {vacateSuperstarChampionships} from "../modules/superstars.js";
import {saveGameDataBaseToCloud} from "./games.js";
import {showReactionDialog} from "./dialog.js";
import {checkTutorialStepAction} from "./tutorial.js";
import {syncUserData} from "../modules/user.js";

$(document).ready(function() {

    // Continue from end event
    $("#game-content").on('click', '#continue', async function () {

        // Don't continue if PoW dialog showing
        if ($('#pow-dialog').is(':visible')) {
            notie.alert({type: 4, text: "Please finish the current action before proceeding"});
            return false;
        }

        let showNextPage = checkShowNextPage();

        // Don't continue if competitors not simulated
        if (!showNextPage && !competitorsSimulated && globals.game.competitorsPresent) {
            showCompetitorsNotSimulatedNotification();
            return false;
        }

        $('.match-container').fadeOut('fast');
        // Show news and viewership
        if (showNextPage) {
            checkToShowNewsAndViewershipContainers();

            // Tutorial action check
            checkTutorialStepAction('go_to_post_event');
        }
        // Go to game
        else {
            await loadHomePage(await getCurrentGame());
        }
    });

    // Continue from viewership page
    $("#game-content").on('click', '#continue-viewership-results-button, #continue-news-button', async function () {

        // Don't continue if competitors not simulated
        if (!competitorsSimulated) {
            showCompetitorsNotSimulatedNotification();
            return false;
        }

        // Go to home page
        await loadHomePage(await getCurrentGame());
    });

    // Viewership options
    $("#game-content").on('click', '.viewership-results-box-option', function () {
        $('.viewership-results-box-option').removeClass('medium-grey').addClass('extra-light-grey');
        $(this).addClass('medium-grey').removeClass('extra-light-grey');

        let val = $(this).text();
        if (val === 'Number') {
            $('.viewership-results-item-container').each(function (i, e) {
                let viewership = parseInt($(e).attr('data-viewership'));
                let viewershipText = getViewershipText(viewership);
                $(e).find('.viewership-results-item-number').text(viewershipText);
            });
        }
        else if (val === 'Rating') {
            $('.viewership-results-item-container').each(function (i, e) {
                let rating = $(e).attr('data-nielsen-rating');
                $(e).find('.viewership-results-item-number').text(rating);
            });
        }
    });

    $("#event-updates").on('click', '.vacate-superstar-championships-button', async function () {
        let element = $(this);
        let superstarUid = parseInt(element.attr('data-superstar-uid'));
        await makeGameRequest(vacateSuperstarChampionships, {superstarUid}, showVacateSuperstarChampionshipsData,
            {element}, false);
    });

    function showCompetitorsNotSimulatedNotification() {
        let notieText = 'Please wait for competitors to finish simulating';
        notie.alert({type: 3, text: notieText});
    }

    function checkShowNextPage() {
        return globals.game.competitorsPresent && $('#continue').data('skipPostEvent') !== true &&
            ($('#continue').data('showNews') === true || (globals.game.marketSize && (globalUser.paid ||
                globals.currentTutorialStep))) &&
            !(globals.currentTutorialStep && globals.currentTutorialStep['action'] !== 'go_to_post_event')
    }

    function checkToShowNewsAndViewershipContainers() {
        if ($('#continue').data('showNews') === true) {
            $('.news-box').fadeIn();
            $('.news-content').scrollTop(0);
        }
        if (globals.game.marketSize && (globalUser.paid || globals.currentTutorialStep)) {
            $('.viewership-results-box').fadeIn();
            $('.viewership-results-box-container').scrollTop(0);
            $('.news-box-buttons-container').hide();
        }
        else {
            $('.news-box-buttons-container').show();
        }
    }
});

async function showPlayEventData({data} = {}) {
    if (!data['error']) {
        // Select menu button
        $('.main-menu-container').find('li').removeClass('selected');
        $('#play-event').addClass('selected');

        // Disable menu options
        resetMenuButtonClickHandlers(disabledMenuButtonHandler);

        // Reset ui
        $("#main-menu-right").html('');
        $("#multi-match-info").html('');
        $(".event-hype").html('');
        $(".event-prestige-effects").hide();
        $(".event-prestige-effects-container").hide();
        $('#event-card').hide();
        $("#matches").html('');
        $("#match").html('');
        $('#booking-talent-info').hide();
        $('.tooltip').remove();
        $("#prestige-results").html('<div class="event-prestige-header font-mukta-mahee font-1p325em menu-header-color margin-bottom-20">Prestige</div>').hide();
        $('#continue-container').hide();

        // Check to show event preview or continue to play event
        let showEventPreview = !(globalUser.settings['showEventPreview'] === false);
        let clickPlayEventTutorialStep = globals.currentTutorialStep && globals.currentTutorialStep['action'] === 'click_play_event';
        if (data['eventPreviewData'] && showEventPreview && !clickPlayEventTutorialStep) {
            showEventPreviewData(data['eventPreviewData']);
            $('#event-preview-continue-button').data('continue-to-event', false);

            // Continue button
            $('#event-preview-container').off('click', '#event-preview-continue-button');
            $('#event-preview-container').on('click', '#event-preview-continue-button', async function () {
                if (!$(this).data('continue-to-event')) {
                    showEventPredictionsData(data['eventPreviewData']['predictionsData'], data['eventPreviewData']['activeEffect']);
                    $(this).data('continue-to-event', true);
                }
                else {
                    $('#event-preview-container').hide();
                    $('#event-preview-poster-container').hide();
                    await showPlayEventPageData(data)
                }
            });
        }
        else {
            await showPlayEventPageData(data)
        }

        // Tutorial action check
        checkTutorialStepAction('click_play_event');
    } else {
        if (data['error'] === 'training-callup-available') {
            notie.confirm({
                text: "A Training Roster Callup is available. Are you sure you want to skip it?",
                submitText: 'Yes',
                cancelText: 'No',
                submitCallback: async function () {
                    await playEventHandler(true, true)
                },
                cancelCallback: async function () {
                    await loadAvailableCallupsPage();
                }
            });
        }
        else {
            let text;
            if (data['error'] === 'team-members-not-found') {
                text = 'Team members could not be found for {0}. Try deleting their Match/Segment.'.format(data['teamName']);
            } else if (data['error'] === 'min-limit') {
                text = "You need to book at least " + data['limit'] + " Matches/Segments for this Event";
            } else {
                text = 'An error occurred while starting the event';
            }
            notie.alert({type: 3, text: text});
        }
    }
}

async function showPlayEventPageData(data) {
    let eventHype = getEventHypeHtml(data['hype']);

    // Add empty match results box
    let fatigueHtml = (globals.game.settings['enable_fatigue'] !== false) ? '<span class="hide-stats extra-light-grey cursor-pointer margin-left-8">Fat.</span>' : '';
    $('#event-match-results').html(
        '<div class="margin-bottom-15 event-results-header">' +
        '<span class="font-mukta-mahee font-1p325em menu-header-color">Results</span>' +
        '<div class="float-right">' +
        '<span class="hide-stats extra-light-grey cursor-pointer">XP</span>' +
        '<span class="hide-stats medium-grey cursor-pointer margin-left-8">Ovr.</span>' +
        '<span class="hide-stats medium-grey cursor-pointer margin-left-8">Pop.</span>' +
        '<span class="hide-stats extra-light-grey cursor-pointer margin-left-8">Gim.</span>' +
        '<span class="hide-stats medium-grey cursor-pointer margin-left-8">Feuds</span>' +
        '<span class="hide-stats medium-grey cursor-pointer margin-left-8">Mor.</span>' +
        fatigueHtml +
        '</div>' +
        '<div class="clear"></div>' +

        '<div class="margin-top-25 margin-bottom-25 line-height-24px">' +
        '<span class="dark-grey font-mukta-mahee font-1p325em">' + data['eventName'] + '</span>' +
        '<div class="float-right">' +
        '<span class="display-block medium-dark-grey font-bold">' + eventHype + ' HYPE' + '</span>' +
        '</div>' +
        '</div>' +

        '</div>' +
        '<div class="margin-bottom-20 light-grey empty-event-match-results-text">No matches or segments played</div>'
    ).show();

    // Add update containers for each category of updates
    $("#event-updates").html(
        '<div class="event-updates-header font-mukta-mahee font-1p325em menu-header-color margin-bottom-20">Updates</div>' +
        '<div class="event-updates-availability display-none margin-bottom-15">' +
        '<div class="light-grey font-0p925em margin-bottom-5">Availability</div>' +
        '<div class="updates-container"></div>' +
        '</div>' +
        '<div class="event-updates-overness display-none margin-bottom-20">' +
        '<div class="light-grey font-0p925em margin-bottom-5">Overness</div>' +
        '<div class="updates-container"></div>' +
        '</div>' +
        '<div class="event-updates-gimmicks display-none margin-bottom-20">' +
        '<div class="light-grey font-0p925em margin-bottom-5">Gimmicks</div>' +
        '<div class="updates-container"></div>' +
        '</div>' +
        '</div>' +
        '<div class="event-updates-feuds display-none margin-bottom-20">' +
        '<div class="light-grey font-0p925em margin-bottom-5">Feuds</div>' +
        '<div class="updates-container"></div>' +
        '</div>' +
        '<div class="event-updates-other display-none">' +
        '<div class="light-grey font-0p925em margin-bottom-5">Other</div>' +
        '<div class="updates-container"></div>' +
        '</div>'
    ).hide();

    // Load match result settings
    let matchResultSetting = globalUser.settings['matchResult'];
    if (matchResultSetting) {
        $('.hide-stats').each(function (i, e) {
            switch ($(e).text()) {
                case 'Ovr.':
                    if (!matchResultSetting.overness) {
                        $(e).removeClass('medium-grey').addClass('extra-light-grey')
                    } else {
                        $(e).removeClass('extra-light-grey').addClass('medium-grey')
                    }
                    break;
                case 'XP':
                    if (!matchResultSetting.xp) {
                        $(e).removeClass('medium-grey').addClass('extra-light-grey')
                    } else {
                        $(e).removeClass('extra-light-grey').addClass('medium-grey')
                    }
                    break;
                case 'Pop.':
                    if (!matchResultSetting.popularity) {
                        $(e).removeClass('medium-grey').addClass('extra-light-grey')
                    } else {
                        $(e).removeClass('extra-light-grey').addClass('medium-grey')
                    }
                    break;
                case 'Gim.':
                    if (!matchResultSetting.gimmickEffectiveness) {
                        $(e).removeClass('medium-grey').addClass('extra-light-grey')
                    } else {
                        $(e).removeClass('extra-light-grey').addClass('medium-grey')
                    }
                    break;
                case 'Feuds':
                    if (!matchResultSetting.feuds) {
                        $(e).removeClass('medium-grey').addClass('extra-light-grey')
                    } else {
                        $(e).removeClass('extra-light-grey').addClass('medium-grey')
                    }
                    break;
                case 'Mor.':
                    if (matchResultSetting.morale === false) {
                        $(e).removeClass('medium-grey').addClass('extra-light-grey')
                    } else {
                        $(e).removeClass('extra-light-grey').addClass('medium-grey')
                    }
                    break;
                case 'Fat.':
                    if (!matchResultSetting.fatigue) {
                        $(e).removeClass('medium-grey').addClass('extra-light-grey')
                    } else {
                        $(e).removeClass('extra-light-grey').addClass('medium-grey')
                    }
                    break;
            }
        })
    }

    // Run matches and segments
    return showPlayMatchOrSegmentPage({data});
}

async function showPlayMatchOrSegmentPage({data, index = 0} = {}) {
    if (data['matchesAndSegmentsData'].length > 0 && index < data['matchesAndSegmentsData'].length) {
        // Play next match/segment
        if (data['matchesAndSegmentsData'][index]['segmentType'] === 'match') {
            await showPlayMatchPage({
                matchesAndSegmentsData: data['matchesAndSegmentsData'], index: index,
                tournamentDisplay: data['tournamentDisplay'], cashinData: data['cashinData']
            });
        }
        else {
            await showPlaySegmentPage({
                matchesAndSegmentsData: data['matchesAndSegmentsData'], index: index,
                tournamentDisplay: data['tournamentDisplay'], cashinData: data['cashinData']
            });
        }
    }
    else {
        // End event if end of matches and segments
        await makeGameRequest(endEventRequest, {}, showEndEventRequestData, {}, false);
    }
}

function showEventPreviewData(data) {
    let parent = $('#event-preview-container');

    parent.find('.event-preview-header').text('{0} {1} Preview'.format(data['eventName'], data['eventYear']));
    parent.find('.event-preview-sub-header').text('by The Wrestling Spectator');

    // Preview text
    let previewHtml = '';
    if (data['previewTexts']) {
        data['previewTexts'].forEach(function(previewText, i) {
            if (i === 0) {
                previewHtml += '<div>{0}</div>'.format(previewText);
            }
            else if (i === data['previewTexts'].length - 1) {
                previewHtml += '<div class="margin-top-15 margin-bottom-10">{0}</div>'.format(previewText);
            }
            else {
                previewHtml += '<div class="margin-top-15">{0}</div>'.format(previewText);
            }
        });
    }
    else {
        previewHtml += '<div>{0}</div>'.format(data['introText']);
        previewHtml += '<div class="margin-top-15">{0}</div>'.format(data['interestText']);
        if (data['topMatchesText']) {
            previewHtml += '<div class="margin-top-15">{0}</div>'.format(data['topMatchesText']);
        }
        if (data['matchContractText']) {
            previewHtml += '<div class="margin-top-15">{0}</div>'.format(data['matchContractText']);
        }
        if (data['streakText']) {
            previewHtml += '<div class="margin-top-15">{0}</div>'.format(data['streakText']);
        }
        previewHtml += '<div class="margin-top-15 margin-bottom-10">Continue on to see our predictions for the event.</div>';
    }

    parent.find('.event-preview-box').html(previewHtml);
    parent.fadeIn();
    parent.find('.event-preview-box').scrollTop(0);

    // Show poster
    showEventPosterPageGraphic(data['eventPosterData'], $('#event-preview-poster-container'))
}

function showEventPredictionsData(data, eventActiveEffect) {
    let parent = $('#event-preview-container');
    let previewHtml = '';

    let POWSponsorsText = '';
    if (eventActiveEffect === 'premier_event') {
        POWSponsorsText = ', one of the attending sponsors,'
    }

    previewHtml += '<div class="margin-bottom-15">Here is {0}{1} with {2} predictions for the event:</div>'.format(data['journalistName'], POWSponsorsText, data['journalistPossessivePronoun']);
    data['predictions'].forEach(function (prediction) {
        previewHtml += '<div class="margin-bottom-15">' +
            '<div class="margin-bottom-5 font-bold">' + prediction['matchText'] + '</div>' +
            '<div class="font-style-italic">Prediction: ' + prediction['predictionText'] + '</div>' +
            '</div>';
    });

    previewHtml += '<div class="margin-top-15 margin-bottom-15">Let\'s see how those predictions hold up at the event.</div>';

    parent.find('.event-preview-box').html(previewHtml);
    parent.find('.event-preview-box').scrollTop(0);
}

function getEventHypeHtml(eventHype) {
    if (eventHype < 0) {
        eventHype = '- ' + (eventHype * -1)
    } else {
        eventHype = '+ ' + eventHype
    }
    return '<span class="event-hype-text">' + eventHype + '</span>';
}

async function showEndEventRequestData({data} = {}) {
    if (!data['error']) {
        // Show post event dialog for PoW
        if (data['postEventDialogs'] && data['postEventDialogs'].length > 0) {
            showReactionDialog(data['postEventDialogs'])
        }

        // Update ui
        $('#progress-segment-button').remove();
        $('.match-container').show();
        $('#superstar_info').removeClass('match');
        $('#continue-container').show();

        // Reset viewership, load post event
        resetViewershipContainer(data);
        await loadPostEventData(data);

        // Show event result
        showEventResult(data);

        // Show updates
        showEndEventUpdates(data);
        showUpdatesContainers();
        updateGamePointsAndFans(data['points'], data['fans']);

        // Tutorial action check
        if (data['nextTutorialState']) {
            globals.game.tutorialState = data['nextTutorialState']
        }

        // Tutorial action check
        checkTutorialStepAction('click_event_continue');

        // Save to cloud
        if (!globalUser.developerMode) {
            await saveGameDataBaseToCloud(false);
            await syncUserData();
        }
    }
    else {
        let errorText = 'There was an error ending the Event.';
        notie.alert({type: 3, text: errorText});
    }
}

function resetViewershipContainer(data) {
    $('.viewership-results-box-container').html('');
    if (data['weeklyShow']) {
        $('.viewership-results-box-header').text('Viewers');
        $('.viewership-results-box-options').show();
        $('.viewership-results-box-option').removeClass('medium-grey').addClass('extra-light-grey');
        $('.viewership-results-box-option').eq(0).addClass('medium-grey').removeClass('extra-light-grey');
    } else {
        $('.viewership-results-box-header').text('Buys');
        $('.viewership-results-box-options').hide();
    }
}

let competitorsSimulated = true;

async function loadPostEventData(data) {
    // Update whether to skip post event
    if (data['skipSimulateCompetitors']) {
        $('#continue').data('skipPostEvent', true);
    } else {
        $('#continue').data('skipPostEvent', false);
    }

    // Simulate competitors
    if (globals.game.competitorsPresent && !data['skipSimulateCompetitors']) {
        competitorsSimulated = false;
        let showNews = !data['weeklyShow'];
        $('#continue').data('showNews', showNews);
        $(".news-content").html('');
        await makeGameRequest(simulateCompetitors, {}, showSimulateCompetitorsData, {showNews}, false);
    }
}

function showEventResult(data) {
    let eventResultsSelector = $("#event-match-results");

    // Add rating
    let ratingStarsHtml = getStarRatingHtml(data['rating']);
    let ratingHelpText;
    if (globals.game.story === 'mars') {
        ratingHelpText = 'Average of Solar Wrestling News, EarthSideMatch and CircledSquare';
    } else {
        ratingHelpText = 'Average of The Wrestling Spectator, RingSideChairs and CircledSquare';
    }
    let ratingHtml =
        '<span class="match-star-rating help-text" title="' + ratingHelpText + '" role="text" aria-label="Event Rating: '
        + data['rating'] + ' stars' + '">' + ratingStarsHtml + '</span>';

    // Display points and fans increase
    let pointsHtml;
    if (data['pointsToAdd'] >= 0) {
        pointsHtml =
            '<span class="event-results-points-change margin-bottom-10 font-1p125em help-text" ' +
            'title="Depends on Event Rating">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small"/>' +
            '<i class="fa fa-angle-double-up margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Increase"></i>' +
            '<span class="dark-grey">' + data['pointsToAdd'] + '</span></span>';
    } else {
        pointsHtml =
            '<span class="event-results-points-change margin-bottom-10 font-1p125em help-text" ' +
            'title="Depends on Event Rating">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small"/>' +
            '<i class="fa fa-angle-double-down margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Decrease"></i>' +
            '<span class="dark-grey">' + data['pointsToAdd'] + '</span></span>';
    }

    let fansHtml = '';
    let hypeMultiplier = '';
    if (data['fansGained'] !== undefined) {
        // Show fans for old system
        let fans = data['fansGained'].toLocaleString();
        if (data['fansGained'] >= 0) {
            fansHtml =
                '<span class="event-results-fan-change margin-left-15 margin-bottom-10 font-1p125em help-text" ' +
                'title="Fan Change: Depends on Event Rating, Fan Multiplier and Company Reputation">' +
                '<img alt="Fans" src="static/www/static/fans_icon.png" class="points-image-small"/>' +
                '<i class="fa fa-angle-double-up margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Increase"></i>' +
                '<span class="dark-grey">' + fans + '</span></span>';
        } else {
            fansHtml =
                '<span class="event-results-fan-change margin-left-15 margin-bottom-10 font-1p125em help-text" ' +
                'title="Fan Change: Depends on Event Rating, Fan Multiplier and Company Reputation">' +
                '<img alt="Fans" src="static/www/static/fans_icon.png" class="points-image-small"/>' +
                '<i class="fa fa-angle-double-down margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Decrease"></i>' +
                '<span class="dark-grey">' + fans + '</span></span>';
        }
        hypeMultiplier =
            '<span class="event-results-fan-change margin-left-15 margin-bottom-10 font-1p125em help-text" ' +
            'title="Fan Multiplier: Depends on Event Hype.">' +
            '<span class="faded-red-light">' + data['hypeMultiplier'] + 'x</span></span>';
    }

    // Add to event results
    eventResultsSelector.append(
        '<div class="event-results-container" tabindex="0">' +
        '<div class="col1 font-mukta-mahee font-1p125em">' +
        pointsHtml + fansHtml + hypeMultiplier +
        '</div>' +
        '<div class="col2 text-right">' +
        ratingHtml +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>'
    );
}

function showEndEventUpdates(data) {
    let prestigeResultsSelector = $("#prestige-results");
    let eventUpdatesSelector = $(".event-updates-other .updates-container");
    let eventUpdatesAvailabilitySelector = $(".event-updates-availability .updates-container");
    let eventUpdatesOvernessSelector = $(".event-updates-overness .updates-container");
    let eventUpdatesFeudsSelector = $(".event-updates-feuds .updates-container");

    // Match contracts not held
    data['matchContractsNotUsed'].forEach(function (contract) {
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            'Due to the ' +
            '<span class="gold">' + contract['matchContract'] + ' Contract</span>' +
            ' not being used, ' +
            'fans were disappointed' +
            '<img alt="Fans" src="static/www/static/fans_icon.png" class="points-image-small margin-right-5 margin-left-8"/>' +
            '<i class="fa fa-angle-double-down margin-right-5 red"></i>' +
            '<span class="red">' + contract['penalty'].toLocaleString('en') + '</span>' +
            '<span/>'
        )
    });

    // Trade returns
    if (data['tradeReturns'].length > 0) {
        let text;
        if (data['tradeReturns'].length > 1) {
            text = '<span class="display-block">' +
                data['tradeReturns'].slice(0, -1).join(', ') + ' and ' +
                data['tradeReturns'].slice(-1) +
                " have left due to the trade deal ending" +
                '</span>';
        } else {
            text = '<span class="display-block">' +
                data['tradeReturns'][0] + " left due to the trade deal ending" +
                '</span>';
        }
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    }

    // Vacated titles
    data['vacated'].forEach(function (vacated) {
        let text;
        let championshipName = getChampionshipDisplayName(vacated);
        if (!vacated['tagTeam'] && !vacated['trio']) {
            text = '<span class="gold">' + championshipName + '</span>' +
                ' has been vacated'
        } else {
            text = '<span class="gold">' + championshipName + '</span>' +
                ' have been vacated'
        }
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Event prestige
    if (data['eventPrestige']) {
        let progress = 100;
        if (data['eventPrestige']['prestige'] !== 'A') {
            progress = ((data['eventPrestige']['xp'] - data['eventPrestige']['baseXp']) /
                (data['eventPrestige']['xpToNextPrestige'] -
                    data['eventPrestige']['baseXp'])) * 100;
        }

        if (progress > 100) {
            progress = 100
        } else if (progress < 0) {
            progress = 0
        }

        let xpChangeHtml;
        let xpChange = data['eventPrestige']['xpChange'];
        if (data['eventPrestige']['xpChange'] >= 0) {
            xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + '</span>'
        } else if (data['eventPrestige']['xpChange'] < 0) {
            xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' +
                (-1 * xpChange) + '</span>'
        }

        let prestigeIcon;
        switch (data['eventPrestige']['prestige']) {
            case 'C':
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
                break;
            case 'B':
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
                break;
            case 'A':
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
                break;
        }

        let prestigeText =
            '<div class="display-block margin-bottom-5">' +
            '<div class="display-inline-block">' +
            '<span>' + data['eventPrestige']['name'] + '</span>' +
            prestigeIcon +
            '</div>' +
            '<div class="display-inline-block float-right">' +
            '<span class="margin-left-5 dark-grey prestige-xp">XP' +
            xpChangeHtml + '</span>' +
            '</div>' +
            '</div>' +
            '<div class="progress-under help-text" title="' + data['eventPrestige']['xp'] + ' / ' +
            data['eventPrestige']['xpToNextPrestige'] + ' XP">' +
            '<div class="progress" style="width:' + progress + '%">' + '</div>' +
            '</div>';

        if (data['eventPrestige']['prestigeIncrease']) {
            prestigeText += '<span class="gold display-block margin-top-12">Event Prestige Increased</span>';
            prestigeText += '<span class="display-block grey margin-top-5">' +
                '<i class="fa fa-angle-double-up margin-right-5"></i>' +
                'Match Limit increased to ' +
                data['eventPrestige']['matchLimit'] + ' for this Event</span>';
        } else if (data['eventPrestige']['prestigeDecrease']) {
            prestigeText += '<span class="puke-green display-block margin-top-12">Event Prestige Decreased</span>';
            prestigeText += '<span class="display-block grey margin-top-5">' +
                '<i class="fa fa-angle-double-down margin-right-5"></i>' +
                'Match Limit decreased to ' +
                data['eventPrestige']['matchLimit'] + ' for this Event</span>';
        }

        prestigeResultsSelector.find('.event-prestige-header').after('<div class="event-prestige-progress' +
            ' margin-bottom-25">' +
            prestigeText + '</div>');
        $('.event-prestige-progress .prestige-xp-value').hide().fadeIn('slow');

        setTimeout(function () {
            $('.event-prestige-progress .progress').addClass("expand-width");
        }, 0);
        setTimeout(function () {
            $('.event-prestige-progress .progress').removeClass("expand-width");
        }, 1800);
    }

    // Reputation for old system
    if (data['reputation'] !== undefined) {

        // Show reputation level
        let progress;
        let max = '';
        if (data['reputation'] < 10) {
            progress = ((data['fans'] - data['previousReputation']) /
                (data['nextReputation'] - data['previousReputation'])) * 100;
        } else {
            progress = 100;
            max = 'MAX'
        }

        if (progress > 100) {
            progress = 100
        } else if (progress < 0) {
            progress = 0
        }

        let xpChangeHtml;
        let xpChange = data['reputationXpChange'];

        if (xpChange >= 0) {
            xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + '</span>'
        } else if (xpChange < 0) {
            xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' +
                (-1 * xpChange) + '</span>'
        }

        let levelText =
            '<div class="display-block margin-bottom-5">' +
            '<div class="display-inline-block">' +
            '<span class="margin-right-5">' + data['companyName'] + ' REP</span>' +
            '<span>' + data['reputation'] + '</span>' +
            '<span class="margin-left-8 red">' + max + '</span>' +
            '</div>' +
            '<div class="display-inline-block float-right">' +
            '<span class="margin-left-5 dark-grey prestige-xp">XP' +
            xpChangeHtml + '</span>' +
            '</div>' +
            '</div>' +
            '<div class="progress-under help-text" title="' + data['reputationXp'].toLocaleString('en') +
            ' / ' + data['xpToNextReputation'].toLocaleString('en') + ' XP">' +
            '<div class="progress" style="width:' + progress + '%">' + '</div>' +
            '</div>';

        if (data['reputationIncrease']) {
            levelText += '<span class="gold display-block margin-top-12">Reputation Increased</span>'
        } else if (data['reputationDecrease']) {
            levelText += '<span class="puke-green display-block margin-top-12">Reputation Decreased</span>'
        }

        // Show new roster size upon reputation increase
        if (data['rosterSize'] && !globals.game.maximumRosterCapacity) {
            let rosterText;
            if (data['reputationIncrease']) {
                rosterText =
                    '<span class="display-block grey">' +
                    '<i class="fa fa-angle-double-up margin-right-5"></i>' +
                    'Roster size increased to ' + data['rosterSize'] + '</span>';

            } else {
                rosterText =
                    '<span class="display-block grey">' +
                    '<i class="fa fa-angle-double-down margin-right-5"></i>' +
                    'Roster size decreased to ' + data['rosterSize'] + '</span>';
            }
            levelText +=
                '<span class="display-block margin-top-5">' + rosterText +
                '</span>';
        }

        prestigeResultsSelector.find('.event-prestige-header').after('<div class="company-reputation ' +
            'margin-bottom-25">' + levelText + '</div>');
        $('.company-reputation .prestige-xp-value').hide().fadeIn('slow');

        setTimeout(function () {
            $('.company-reputation .progress').addClass("expand-width");
        }, 0);
        setTimeout(function () {
            $('.company-reputation .progress').removeClass("expand-width");
        }, 1800);
    }

    // Expiring championship contracts
    data['expiringChampionships'].forEach(function (championship) {
        let text = '<span class="display-block">' +
            '<span class="gold">' + championship + '</span> will expire at the upcoming event' +
            '</span>';
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Expired championship contracts
    data['expiredChampionships'].forEach(function (championship) {
        let text = '<span class="display-block">' +
            '<span class="gold">' + championship + '</span> has expired' +
            '</span>';
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Feud potential
    if (data['feudPotential']) {
        let feudPotentialHtml = getFeudPotentialHtml(data['feudPotential'])
        eventUpdatesFeudsSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            feudPotentialHtml +
            '</span>'
        );
    }

    // Feud hype increased
    if (data['feudHypeIncreased']) {
        let feudHypeIncreased = getFeudHypeIncreasedHtml(data['feudHypeIncreased'])
        eventUpdatesFeudsSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            feudHypeIncreased +
            '</span>'
        );
    }

    // Not used at event
    if (data['notUsedAtEvent'].length > 3) {
        // Show together if more than 4 changes
        let overnessDecreases = Array.from(data['notUsedAtEvent'], function (s) {
            return s['name'];
        });
        if (overnessDecreases.length > 1) {
            overnessDecreases = overnessDecreases.slice(0, -1).join(', ') + ' and ' + overnessDecreases.slice(-1)
        } else {
            overnessDecreases = overnessDecreases.join('')
        }
        let changeWord = (data['notUsedAtEvent'][0]['increase']) ? 'increased' : 'decreased';

        let text = '{0}\'s Overness '.format(overnessDecreases) + changeWord + ' a Level';
        if (changeWord === 'decreased') {
            text += ' due to not being used at the Event.'
        }
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    } else {
        data['notUsedAtEvent'].forEach(function (overnessChange) {
            let overnessPercentage = '<span class="light-grey margin-left-5">' + overnessChange['overness'] +
                '<span class="margin-left-2">%</span></span>'
            let changeWord = (overnessChange['increase']) ? 'increased' : 'decreased';
            let text =
                '{0}\'s Overness{1} '.format(overnessChange['name'], overnessPercentage) + changeWord +
                ' from <span class="light-grey">' + overnessChange['previousOverness'] +
                ' to ' +
                overnessChange['currentOverness'] + '</span>';

            if (changeWord === 'decreased') {
                text += ' due to not being used at the Event.'
            }
            eventUpdatesOvernessSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        });
    }

    // Hot changes
    data['hotChanges'].forEach(function (hotChange) {
        let text;
        if (hotChange['status'] === 'hotStart') {
            text = hotChange['name'] + ' is starting to get <span class="hot-color">Over</span> with the Fans'
        } else if (hotChange['status'] === 'hotEnd') {
            text = hotChange['name'] + ' is no longer <span class="hot-color">Over</span> with the Fans. ' +
                'All boosts have been removed.'
        } else if (hotChange['status'] === 'hot') {
            text = hotChange['name'] + ' got <span class="hot-color hot-text">Over</span> with the Fans, ' +
                ' boosting ' + hotChange['pronoun'] + ' Attributes and performance in Matches, Segments and Feuds.'
        }
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )

        setTimeout(function () {
            $(".hot-text").addClass("flash-text-orange");
        }, 200);
        setTimeout(function () {
            $(".hot-text").removeClass("flash-text-orange");
        }, 3000);
    });

    // Stale changes
    data['staleChanges'].forEach(function (staleChange) {
        let text;
        if (staleChange['status'] === 'staleStart') {
            text = staleChange['name'] + ' is starting to become <span class="stale-color">Stale</span> with the Fans'
        } else if (staleChange['status'] === 'staleEnd') {
            text = staleChange['name'] + ' is no longer <span class="stale-color">Stale</span> with the Fans. ' +
                'All negative effects have been removed.'
        } else if (staleChange['status'] === 'stale') {
            text = staleChange['name'] + ' became <span class="stale-color stale-text">Stale</span> with the Fans, ' +
                ' lowering ' + staleChange['pronoun'] + ' performance in Matches, Segments and Feuds.'
        }
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )

        setTimeout(function () {
            $(".stale-text").addClass("flash-text-stale");
        }, 200);
        setTimeout(function () {
            $(".stale-text").removeClass("flash-text-stale");
        }, 3000);
    });

    // Rehabbed
    data['rehabbed'].forEach(function (rehab) {
        let doctorAgeMultiplier = rehab['doctorAgeMultiplier'];
        let doctorXp = '<span class="green margin-left-8">+ ' + rehab['doctorXpGained'] + ' XP</span>';
        if (doctorAgeMultiplier !== 1) {
            doctorXp += '<span class="light-grey margin-left-8 font-0p925em">(' +
                doctorAgeMultiplier + '<span class="help-text" title="Age affects progression of ' +
                'Skill Level. Younger staff members gain XP faster than older ones.">x Age Multiplier</span>)' +
                '</span>'
        }
        let text =
            '{0}\'s recovery from <span class="dark-red">injury</span> was helped by rehab from {1}{2}'
                .format(rehab['name'], rehab['doctorName'], doctorXp);
        eventUpdatesAvailabilitySelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Staff skill increases
    data['staffSkillIncreases'].forEach(function (staffMember) {
        let roleHtml = '<span class="light-grey">(' + toTitleCase(staffMember['role'].replace(/_/g, " ")) + ')</span>';
        let skillLevelHtml = '<span class="staff-color">Skill</span>';
        let text =
            '{0}\'s {1} {2} increased to <span class="gold">Level {3}</span>'
                .format(staffMember['name'], roleHtml, skillLevelHtml, staffMember['level']);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Staff tasks completed
    data['staffTasksCompleted'].forEach(function (task) {
        let taskHtml = '<span class="medium-grey">' + task['name'] + '</span>';
        let xpGained = '<span class="green margin-left-5">+ ' + task['xpGained'] + ' XP</span>';
        if (task['xpAgeMultiplier'] !== 1) {
            xpGained += '<span class="light-grey margin-left-8 font-0p925em">(' +
                task['xpAgeMultiplier'] + '<span class="help-text" title="Age affects progression of ' +
                'Skill Level. Younger staff members gain XP faster than older ones.">x Age Multiplier</span>' +
                ')</span>'
        }

        let text = '{0} completed the {1} task {2}</span>'.format(task['staffMember'],
            taskHtml, xpGained)
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });


    // Staff actions completed
    data['staffActionsCompleted'].forEach(function (task) {
        let xpGained = '<span class="green margin-left-8">+ ' + task['xpGained'] + ' XP</span>';
        if (task['xpAgeMultiplier'] !== 1) {
            xpGained += '<span class="light-grey margin-left-8 font-0p925em">(' +
                task['xpAgeMultiplier'] + '<span class="help-text" title="Age affects progression of ' +
                'Skill Level. Younger staff members gain XP faster than older ones.">x Age Multiplier</span>' +
                ')</span>'
        }
        let text = '{0} {1} {2}</span>'.format(task['staffMember'], task['name'], xpGained)
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Championships not used
    if (data['championshipsNotUsedRecently']) {
        let xpChange = '<span class="red margin-left-3">- ' +
            (data['championshipNotUsedXpChange'] * -1) + ' XP</span>';
        let championshipNameHtml = '<span class="gold">' + data['championshipsNotUsedRecently']
            + '</span>';
        let text = '<span class="display-block">Prestige of the ' + championshipNameHtml +
            ' decreased due to not being used in over 6 months ' +
            xpChange + '</span>';
        prestigeResultsSelector.find('.event-prestige-header').after(
            '<span class="display-block margin-bottom-15 dark-grey">' + text +
            '</span>'
        )
    }

    // Morale changes
    data['moraleChanges'].forEach(function (moraleChange) {
        let moralePercentage = '<span class="light-grey margin-left-5">' + moraleChange['morale'] +
            '<span class="margin-left-2">%</span></span>';
        let text =
            '{0}\'s Morale{1} '.format(moraleChange['name'], moralePercentage) +
            ' changed to <span class="light-grey">' + moraleChange['currentMorale'] +
            '</span> from <span class="light-grey">' + moraleChange['previousMorale'] + '</span>';
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Morale decreases due to not used
    if (data['notUsedMoraleDecreases'].length > 0) {
        let moraleDecreasesNames = Array.from(data['notUsedMoraleDecreases'], function (s) {
            return s['name'];
        });
        let moralePercentage = '<span class="puke-green margin-left-3">' +
            data['notUsedMoraleDecreases'][0]['decrease'] + '<span class="margin-left-2">%</span></span>';

        let text = '{0}\'s Morale '.format(commaSeparate(moraleDecreasesNames)) + 'decreased by ' + moralePercentage;
        text += ' due to not being used at the Event.'
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    }

    // Popularity decrease due to not used
    if (data['notUsedPopularityDecreases'].length > 0) {
        let popularityDecreasesNames = Array.from(data['notUsedPopularityDecreases'], function (s) {
            return s['name'] + '<span class="margin-left-5 light-grey"><i class="fa fa-angle-double-down margin-right-5"></i>' + (s['decrease']) + '</span>';
        });
        let text = 'Popularity of {0}'.format(commaSeparate(popularityDecreasesNames)) + ' decreased due to not being used at the Event.';
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    }

    // Fotc changes
    data['fotcChanges'].forEach(function (data) {
        let faceOfTheCompanyText;
        if (data['faceOfTheCompany']) {
            faceOfTheCompanyText = data['name'] + ' became a ' +
                '<span class="medium-blue">' +
                'Face of the Company' +
                '</span>!';
        } else {
            faceOfTheCompanyText = data['name'] + ' is no longer a Face of the Company';
        }
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + faceOfTheCompanyText +
            '</span>'
        )
    });

    // Faction reputation progress
    data['factionReputationsData'].forEach(function (factionReputationData) {
        showFactionReputationData(factionReputationData);
    });

    // Company overness changes
    let companyOvernessChange = data['companyOvernessChange'];
    if (companyOvernessChange !== undefined) {
        let overnessPercentage = '<span class="light-grey margin-left-5">' + companyOvernessChange['overness'] +
            '<span class="margin-left-2">%</span></span>'
        let changeWord = (companyOvernessChange['increase']) ? 'increased' : 'decreased';
        let text =
            '{0}\'s Overness{1} '.format(companyOvernessChange['name'], overnessPercentage) + changeWord +
            ' from <span class="light-grey">' + companyOvernessChange['previousOverness'] +
            ' to ' +
            companyOvernessChange['currentOverness'] + '</span>';
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    }

    // Brand overness changes
    let brandOvernessChange = data['brandOvernessChange'];
    if (brandOvernessChange !== undefined) {
        // Get brand name and color
        let brandNameStyleHtml = '';
        if (brandOvernessChange['color'] && !globalUser.settings.colorblindMode) {
            brandNameStyleHtml = ' style="color: ' + brandOvernessChange['color'] + '"';
        }
        let brandNameHtml = '<span' + brandNameStyleHtml + '>' + brandOvernessChange['name'] + '</span>';

        let overnessPercentage = '<span class="light-grey margin-left-5">' + brandOvernessChange['overness'] +
            '<span class="margin-left-2">%</span></span>'
        let changeWord = (brandOvernessChange['increase']) ? 'increased' : 'decreased';
        let text =
            '{0}\'s Overness{1} '.format(brandNameHtml, overnessPercentage) + changeWord +
            ' from <span class="light-grey">' + brandOvernessChange['previousOverness'] +
            ' to ' +
            brandOvernessChange['currentOverness'] + '</span>';
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    }
}

function showSimulateCompetitorsData({data, showNews} = {}) {
    if (data['error']) {
        let text;
        if (data['error'] === 'simulate-competitor-event') {
            text = 'There was an error simulating some competitors. Please continue to your next event. Competitor simulations might not work for the next event but should work afterwards.';
        } else if (data['error'] === 'simulate-competitors') {
            text = 'There was an error simulating competitors. Please continue to your next event. Competitor simulations might not work for the next event but should work afterwards.';
        }
        notie.alert({type: 3, text: text, stay: true});
    }

    competitorsSimulated = true;

    if (data['news'] && showNews) {
        displayNews(data['news']);
    }

    let fanChangeData = data['fanChangeData'];
    if (fanChangeData) {
        if (fanChangeData['viewershipData']) {
            displayViewershipData(fanChangeData['viewershipData'])
        }
        if (fanChangeData['reputationData'].length > 0) {
            displayReputationData(fanChangeData['reputationData'])
        }
    }
}

function displayNews(data) {
    if (globals.game.story === 'mars') {
        if (!globals.game.earth) {
            $(".news-heading").text('Martian Wrestling News');
            $(".news-heading").addClass('mars-red');
            $('.news-box').addClass('mars-box');
        }
        else {
            $(".news-heading").text('Earth Wrestling News');
            $(".news-heading").removeClass('mars-red');
            $('.news-box').removeClass('mars-box');
        }
    }
    else {
        $(".news-heading").text('The Wrestling Spectator');
        $(".news-heading").removeClass('font-1p125em font-bold mars-red margin-bottom-20');
        $(".news-heading").addClass('font-nanum-gothic margin-bottom-10');
        $('.news-box').removeClass('mars-box');
    }
    $(".news-subheading").hide();

    if (data.length) {
        data.forEach(function (news) {
            let newsHtml = getNewsHtml(news, true);
            $(".news-content").append(newsHtml);
        });
    }
    else {
        $(".news-content").append(
            '<div class="margin-bottom-15 news-item font-lora">' +
            'Nothing significant happened this month. Surely things will pick up. ' +
            'It\'s the wrestling business after all.' +
            '</div>'
        )
    }

    if (globals.game.story === 'mars') {
        $(".news-subheading").html(globals.game.month + ', Year ' + globals.game.year).show()
    }
    else {
        $(".news-subheading").html(globals.game.month + ' ' + globals.game.year).show()
    }
}

function getNewsHtml(news, showContent = true, simulation = false) {
    let newsHtml;
    let company = '';
    if (news['company']) {
        company = news['company']
    }

    let content = '';
    if (showContent) {
        content = '<div class="font-normal margin-top-2">' + news['content'] + '</div>'
    }
    if (news['headline'] && !simulation) {
        newsHtml = '<div class="margin-bottom-25 display-block news-item headline">' +
            '<div class="news-item-title font-bold margin-bottom-10 text-center font-libre-bakerville">' +
            news['title'] + '</div>' +
            '<div class="font-lora">' + content + '</div>' +
            '</div>'
    }
    else {
        let newsClass = 'margin-bottom-20';
        if (simulation) {
            newsClass = '';
        }
        newsHtml = '<div class="' + newsClass + ' news-item">' +
            '<div class="font-bold font-libre-bakerville font-15px">' +
                '<span class="company-name grey">' + company + '</span> ' +
                '<span class="news-item-title">' + news['title'] + '</span>' +
            '</div>' +
            '<div class="font-lora">' + content + '</div>' +
            '</div>'
    }
    return newsHtml;
}

function displayViewershipData(data) {
    let html = '';
    data.forEach(function(viewershipData) {
        let fanChangeHtml = '';
        if (viewershipData['fanChange'] !== undefined) {
            let roundedFanChange = Math.round(((viewershipData['fanChange'] / 1000) + Number.EPSILON) * 100) / 100;
            if (roundedFanChange >= 0) {
                let fanChangeText;
                if (roundedFanChange < 1) {
                    fanChangeText = '{0} Fans'.format((roundedFanChange * 1000).toLocaleString('en'))
                } else {
                    fanChangeText = '{0}K Fans'.format(roundedFanChange.toLocaleString('en'))
                }
                fanChangeHtml = '<span class="margin-left-8 light-grey viewership-results-fan-change"><i class="fa fa-angle-double-up top-1px margin-right-5" role="text" aria-label="Increase"></i>' + fanChangeText + '</span>'
            } else {
                let fanChangeText;
                roundedFanChange *= -1;
                if (roundedFanChange < 1) {
                    fanChangeText = '{0} Fans'.format((roundedFanChange * 1000).toLocaleString('en'))
                } else {
                    fanChangeText = '{0}K Fans'.format(roundedFanChange.toLocaleString('en'))
                }
                fanChangeHtml = '<span class="margin-left-8 light-grey viewership-results-fan-change"><i class="fa fa-angle-double-down top-1px margin-right-5" role="text" aria-label="Decrease"></i>' + fanChangeText + '</span>'
            }
            // Show total fan change label
            if (viewershipData['multipleCompanyEvents']) {
                fanChangeHtml += ' <span class="light-grey help-text" title="Total fan change is based on the results ' +
                    'of all weekly shows shown for this company.">(Total)</span>';
            }
        }

        let viewershipText = getViewershipText(viewershipData['viewership']);

        // Get player name
        let playerNameHtml = '';
        if (viewershipData['playerName']) {
            playerNameHtml = '<div class="medium-grey">{0}</div>'.format(viewershipData['playerName']);
        }

        // User controlled class
        let userControlledClass = '';
        if (viewershipData['isUserControlled']) {
            userControlledClass = ' user-company'
        }

        // Last weekly show label
        let lastWeeklyShowLabelHtml = '';
        if (viewershipData['pastEvent']) {
            lastWeeklyShowLabelHtml = '<div class="light-grey margin-top-2 help-text" title="Fan change is based on ' +
                'this company\'s last weekly show.">Last Weekly Show</div>';
        }

        // Brand
        let brandNameHtml = '';
        let eventStyleHtml = '';
        if (viewershipData['weeklyShow']) {
            // Add brand color to event name for weekly shows
            if (viewershipData['brandColor']) {
                if (viewershipData['brandColor'] && !globalUser.settings.colorblindMode) {
                    eventStyleHtml = ' style="color: ' + viewershipData['brandColor'] + '"';
                }
            }
        }
        else {
            // Show brand name with color for monthly events
            if (viewershipData['brandName']) {
                let brandNameStyleHtml = '';
                if (viewershipData['brandColor'] && !globalUser.settings.colorblindMode) {
                    brandNameStyleHtml = ' style="color: ' + viewershipData['brandColor'] + '"';
                }
                brandNameHtml = ' <span class="medium-grey display-inline-block"' + brandNameStyleHtml + '>' +
                    viewershipData['brandName'] + '</span>';
            }
        }

        html +=
            '<div class="viewership-results-item-container' + userControlledClass + '" data-viewership="' + viewershipData['viewership'] + '" ' +
            'data-nielsen-rating="' + viewershipData['nielsenRating'] + '">' +
                '<div class="viewership-results-item-column-left">' +
                '<div class="margin-bottom-12 font-1p25em darker-grey line-height-24px"' + eventStyleHtml + '>' + viewershipData['event'] + '</div>' +
                '<div>' +
                    '<span class="medium-grey">' + viewershipData['company'] + '</span>' +
                    brandNameHtml +
                    fanChangeHtml +
                    playerNameHtml +
                    lastWeeklyShowLabelHtml +
                '</div>' +
                '</div>' +
                '<div class="viewership-results-item-column-right text-right">' +
                    '<div class="font-1p4em margin-bottom-15 darker-grey viewership-results-item-number display-inline-block">' + viewershipText + '</div>' +
                    '<div class="font-1p125em" role="text" aria-label="Latest Event Rating: ' + viewershipData['rating'] + ' stars' + '">' + getStarRatingHtml(viewershipData['rating']) + '</div>' +
                '</div>' +
                '<div class="clear"></div>' +
            '</div>';
    });

    $('.viewership-results-box-container').html(html);
}

function displayReputationData(data) {
    data.forEach(function(reputationData) {
        // Show reputation level
        let progress;
        let max = '';
        if (reputationData['reputation'] < 10) {
            progress = ((reputationData['reputationXp'] - reputationData['xpToPreviousReputation']) /
                (reputationData['xpToNextReputation'] - reputationData['xpToPreviousReputation'])) * 100;
        } else {
            progress = 100;
            max = 'MAX'
        }

        if (progress > 100) {
            progress = 100
        } else if (progress < 0) {
            progress = 0
        }

        let xpChangeHtml;
        let xpChange = reputationData['reputationXpChange'];

        if (xpChange >= 0) {
            xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + '</span>'
        } else if (xpChange < 0) {
            xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' +
                (-1 * xpChange) + '</span>'
        }

        let levelText =
            '<div class="display-block margin-bottom-5">' +
            '<div class="display-inline-block">' +
            '<span class="margin-right-5">' + reputationData['companyName'] + ' REP</span>' +
            '<span>' + reputationData['reputation'] + '</span>' +
            '<span class="margin-left-8 red">' + max + '</span>' +
            '</div>' +
            '<div class="display-inline-block float-right">' +
            '<span class="margin-left-5 dark-grey prestige-xp">XP' +
            xpChangeHtml + '</span>' +
            '</div>' +
            '</div>' +
            '<div class="progress-under help-text" title="' + reputationData['reputationXp'].toLocaleString('en') +
            ' / ' + reputationData['xpToNextReputation'].toLocaleString('en') + ' XP">' +
            '<div class="progress" style="width:' + progress + '%">' + '</div>' +
            '</div>';

        if (reputationData['reputationIncrease']) {
            levelText += '<span class="gold display-block margin-top-12">Reputation Increased</span>'
        } else if (reputationData['reputationDecrease']) {
            levelText += '<span class="puke-green display-block margin-top-12">Reputation Decreased</span>'
        }

        // Show new roster size upon reputation increase
        if (reputationData['rosterSize'] && !globals.game.maximumRosterCapacity) {
            let rosterText;
            if (reputationData['reputationIncrease']) {
                rosterText =
                    '<span class="display-block grey">' +
                    '<i class="fa fa-angle-double-up margin-right-5"></i>' +
                    'Roster size increased to ' + reputationData['rosterSize'] + '</span>';

            } else {
                rosterText =
                    '<span class="display-block grey">' +
                    '<i class="fa fa-angle-double-down margin-right-5"></i>' +
                    'Roster size decreased to ' + reputationData['rosterSize'] + '</span>';
            }
            levelText +=
                '<span class="display-block margin-top-5">' + rosterText +
                '</span>';
        }

        $("#prestige-results").find('.event-prestige-header').after('<div class="company-reputation ' +
            'margin-bottom-25">' + levelText + '</div>');
    });

    $('.company-reputation .prestige-xp-value').hide().fadeIn('slow');

    setTimeout(function () {
        $('.company-reputation .progress').addClass("expand-width");
    }, 0);
    setTimeout(function () {
        $('.company-reputation .progress').removeClass("expand-width");
    }, 1800);

    if (!$("#prestige-results").is(":visible")) {
        $("#prestige-results").fadeIn('slow');
    }
}

function showVacateSuperstarChampionshipsData({data, element} = {}) {
    data['vacatedChampionships'].forEach(function (championship) {
        let verb = (championship['tagTeam'] || championship['trio']) ? 'have' : 'has';
        let championshipName = getChampionshipDisplayName(championship);
        let notieText = '<span class="gold">' + championshipName + '</span> ' + verb + ' been vacated';
        element.parent().after(
            '<span class="display-block margin-bottom-12 dark-grey">' + notieText +
            '</span>'
        )
    });

    element.remove();

    // Tutorial action check
    checkTutorialStepAction('click_vacate_superstar_championships_button');
}

export {showPlayEventData, getEventHypeHtml, showPlayMatchOrSegmentPage, getNewsHtml}